import Vue from 'vue'

let promptLogin = null
let pendingAction = null

const STORAGE_TOKEN = 'paper-zc-token'
const STORAGE_USER = 'paper-zc-user'
const STORAGE_EXPIRES_AT = 'paper-zc-expires-at'
const LOGIN_CACHE_TTL = 24 * 60 * 60 * 1000

function defaultUser() {
  return {
    nickname: 'Paper 用户',
    phone: '未绑定',
    balance: null,
    avatarText: 'P'
  }
}

function readUser() {
  try {
    const raw = window.localStorage.getItem(STORAGE_USER)
    return raw ? { ...defaultUser(), ...JSON.parse(raw), balance: null } : defaultUser()
  } catch (error) {
    return defaultUser()
  }
}

function persistUser(user) {
  window.localStorage.setItem(STORAGE_USER, JSON.stringify(user))
}

function clearStoredLogin() {
  window.localStorage.removeItem(STORAGE_TOKEN)
  window.localStorage.removeItem(STORAGE_USER)
  window.localStorage.removeItem(STORAGE_EXPIRES_AT)
}

function readValidToken() {
  const token = window.localStorage.getItem(STORAGE_TOKEN) || ''
  const expiresAt = Number(window.localStorage.getItem(STORAGE_EXPIRES_AT))
  if (!token) return ''
  if (!Number.isFinite(expiresAt) || expiresAt <= Date.now()) {
    clearStoredLogin()
    return ''
  }
  return token
}

const initialToken = typeof window !== 'undefined' ? readValidToken() : ''

export const authState = Vue.observable({
  loggedIn: false,
  user: defaultUser()
})

if (typeof window !== 'undefined') {
  authState.loggedIn = Boolean(initialToken)
  authState.user = authState.loggedIn ? readUser() : defaultUser()
}

export function isLoggedIn() {
  return Boolean(getToken())
}

export function getUser() {
  return authState.user
}

export function getToken() {
  const token = readValidToken()
  if (!token && authState.loggedIn) {
    authState.loggedIn = false
    authState.user = defaultUser()
    pendingAction = null
  }
  return token
}

export function setLoginPromptHandler(handler) {
  promptLogin = handler
}

export function openLogin() {
  if (promptLogin) promptLogin()
}

export function requireLogin(action) {
  if (isLoggedIn()) {
    if (action) action()
    return true
  }
  pendingAction = action || null
  if (promptLogin) promptLogin()
  return false
}

export function completeLogin(user, token) {
  if (!token) throw new Error('登录 Token 不能为空')
  const source = user || {}
  const nickname = source.nickname || source.nickName || source.userName || defaultUser().nickname
  const nextUser = {
    ...defaultUser(),
    ...source,
    nickname,
    phone: source.phone || source.phonenumber || defaultUser().phone,
    avatarText: source.avatarText || nickname.slice(0, 1).toUpperCase()
  }
  authState.loggedIn = true
  authState.user = nextUser
  window.localStorage.setItem(STORAGE_TOKEN, token)
  window.localStorage.setItem(STORAGE_EXPIRES_AT, String(Date.now() + LOGIN_CACHE_TTL))
  persistUser(nextUser)
  if (pendingAction) {
    const action = pendingAction
    pendingAction = null
    window.setTimeout(action, 120)
  }
}

export function setUserProfile(partial) {
  authState.user = { ...authState.user, ...partial }
  persistUser(authState.user)
}

export function logout() {
  authState.loggedIn = false
  authState.user = defaultUser()
  pendingAction = null
  clearStoredLogin()
}

export function toast(message) {
  window.dispatchEvent(new CustomEvent('paper-toast', { detail: message }))
}
